module.exports = __webpack_public_path__ + "static/media/sign-out.c52df44b.png";